var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeButtonActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4868_1154)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.59375,
    width: 50,
    height: 50,
    rx: 8,
    fill: "#FC7700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.09375,
    width: 49,
    height: 49,
    rx: 7.5,
    stroke: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 39.0938V25.3438M14.5 27.8438V36.5938C14.5 37.9745 15.6193 39.0938 17 39.0938H33.7828C35.6337 39.0938 37.2078 37.7433 37.4892 35.914L38.8354 27.164C39.1848 24.8924 37.4273 22.8438 35.129 22.8438H30.75C30.0596 22.8438 29.5 22.2841 29.5 21.5938V17.176C29.5 15.4737 28.12 14.0938 26.4177 14.0938C26.0117 14.0938 25.6437 14.3329 25.4788 14.7039L21.0799 24.6014C20.8793 25.0528 20.4316 25.3438 19.9377 25.3438H17C15.6193 25.3438 14.5 26.463 14.5 27.8438Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4868_1154",
    x: 0,
    y: 0.59375,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4868_1154"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4868_1154",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeButtonActive);
export default __webpack_public_path__ + "static/media/like Button - active.527a223f04570a11964edecde0cc1090.svg";
export { ForwardRef as ReactComponent };